<template>
  <v-app-bar class="header-tab" height="48px" flat color="orange accent-4">
    <v-toolbar-title>現在管理者としてログイン中です。</v-toolbar-title>

    <v-tab @click="ToForm">新規投稿</v-tab>
    <v-tab @click="Logout">サインアウト</v-tab>
  </v-app-bar>
</template>

<script>
import firebase from "firebase"
export default {
  methods: {
    ToForm() {
      this.$router.push("/form")
    },
    Logout() {
      firebase.auth().signOut()
    },
  },
}
</script>

<style lang="scss" scoped></style>
